var map = {
	"./agriculture/dms/dms.png": 4307,
	"./agriculture/suru/SURU 15.mp4": 2624,
	"./agriculture/suru/suru.png": 3047,
	"./agriculture/suru/suru_left.png": 2735,
	"./agriculture/suru/suru_right.png": 4832,
	"./agriculture/suru/suru_top.png": 8283,
	"./agriculture/suru1/suru1.png": 6487,
	"./agriculture/suru1/suru1_left.png": 6239,
	"./agriculture/suru1/suru1_right.png": 976,
	"./agriculture/suru1/suru1_top.png": 75,
	"./agriculture/truuna/trunna_left.png": 2334,
	"./agriculture/truuna/trunnavid1.mp4": 2709,
	"./agriculture/truuna/truuna.png": 7959,
	"./agriculture/truuna/truuna_right.png": 704,
	"./agriculture/truuna/truuna_top.png": 475,
	"./hospitility/serving/serving.png": 9186,
	"./hospitility/serving/serving_left.png": 44,
	"./hospitility/serving/serving_right.png": 6825,
	"./hospitility/serving/serving_top.png": 8334,
	"./hospitility/servingsmall/serving_small_left.png": 7295,
	"./hospitility/servingsmall/serving_small_right.png": 2560,
	"./hospitility/servingsmall/serving_small_top.png": 3307,
	"./hospitility/servingsmall/servingsmall.png": 4334,
	"./industrial/lifting/lefting_right.png": 1668,
	"./industrial/lifting/lifting.png": 5279,
	"./industrial/lifting/lifting_left.png": 9015,
	"./industrial/lifting/lifting_top.png": 6643,
	"./toys/magicmirror/magicmirror.png": 9661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7311;